import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

export default function Navigation({ companyName, navigation }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className={`text-[#e4e4e4] border-b border-neutral-800/50  ${mobileMenuOpen ? 'py-0' : 'py-2'} sticky top-0 z-50 w-full border-b backdrop-blur supports-[backdrop-filter]:bg-background/60 px-4 lg:px-0`}>
      <nav aria-label="Global" className={`mx-auto max-w-7xl flex items-center justify-between gap-x-6 py-2 ${mobileMenuOpen ? 'hidden' : ''}`}>
        <div className="flex lg:flex-1">
          <a href="/" className="">
            <span className="sr-only">{companyName}</span>
            <img alt={companyName} src="/logo.svg" className="h-8 w-auto" />
          </a>
        </div>
        <div className="">

        </div>
        <div className="hidden lg:flex lg:gap-x-12 items-center">
        {/* {navigation.map((item) => (
            <a key={item.name} href={item.href} className="text-sm font-semibold text-[#e4e4e4]">
              {item.name}
            </a>
          ))} */}
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-[#8a8f98]"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
          </button>
        </div>
      </nav>
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 bg-[#101010] z-20 w-full overflow-y-auto px-4 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center gap-x-6">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">{companyName}</span>
              <img alt={companyName} src="/logo.svg" className="h-8 w-auto" />
            </a>
            <div className='ml-auto'></div>
            <a
              href="/#pricing"
              className="ml-auto rounded-md bg-[#e6e6e6] px-2 py-1 text-sm font-semibold text-[#101010] shadow-sm hover:bg-[#f7f8f8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f7f8f8]"
            >
              Get early access
            </a>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-[#8a8f98]"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-[#e4e4e4] hover:bg-gray-50"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
              <div className="py-6">

              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  )
}
